var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v("An " + _vm._s(_vm.applicantName) + " eine Zusage senden")
      ]),
      _vm._v(" "),
      _c(
        "FormGroup",
        { staticClass: "mt-2" },
        [
          _c("RadioGroup", {
            attrs: { options: _vm.collaborationOptions, stacked: "" },
            model: {
              value: _vm.collaboration,
              callback: function($$v) {
                _vm.collaboration = $$v
              },
              expression: "collaboration"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.collaborationInterest
        ? _c("Interest", {
            staticClass: "mt-3",
            attrs: {
              "applicant-name": _vm.applicantName,
              "company-name": _vm.companyName,
              text: _vm.message.collaborationTexts.interest
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.collaborationAgreementBasic
        ? _c("AgreementBasic", {
            staticClass: "mt-3",
            attrs: {
              "applicant-name": _vm.applicantName,
              "company-name": _vm.companyName,
              text: _vm.message.collaborationTexts.agreementBasic
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.collaborationPromise
        ? _c("Promise", {
            staticClass: "mt-3",
            attrs: {
              "applicant-name": _vm.applicantName,
              "company-name": _vm.companyName,
              text: _vm.message.collaborationTexts.promise
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.collaborationAgreementFull
        ? _c("AgreementFull", {
            staticClass: "mt-3",
            attrs: {
              "applicant-name": _vm.applicantName,
              "company-name": _vm.companyName,
              text: _vm.message.collaborationTexts.agreementFull
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 text-right" },
        [
          _c("Button", {
            attrs: {
              text: "Senden / Bestätigen",
              icon: "checkmark",
              disabled: !_vm.dataValid || _vm.sendingRequest,
              loading: _vm.sendingRequest
            },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }